import React, {  useState } from "react";
import { Alert, Button, Input } from "antd";
import { Method_POST } from "../../../../../../service/api";
import { toast } from "react-toastify";
import { Box, CircularProgress } from "@mui/material";
const { TextArea } = Input;

export function NegociacaoOS({ info, setInfo, setIsModalNegociacaoOS, numeroSolicitacao, fetchData }) {

  const [loading, setLoading] = useState(false);

  const atualizarNegociacao = async () => {
    setLoading(true);
    try {
      const url = `/ordem-servico/valor/atualizar`;
      const data = {
        id: numeroSolicitacao,
        observacaoNegociacao: info.observacaoNegociacao,
        valorAvulso: info.valorAvulso,
        valorAssinatura: info.valorAssinatura,
        valorAdicional: info.valorAdicional,
      };

      const response = await Method_POST(url, data);

      if (response) {
        //console.log("dados:", response);
        setInfo((prevState) => ({
          ...prevState,
          observacaoNegociacao: prevState.observacaoNegociacao,
          valorAvulso: prevState.valorAvulso,
          valorAssinatura: prevState.valorAssinatura,
          valorAdicional: prevState.valorAdicional,
        }));
        toast.success("Negociação feita com sucesso!");
        setIsModalNegociacaoOS(false);
        fetchData();
      }
    } catch (error) {
      console.error("Erro ao buscar dados:", error.message);
    } finally {
      setLoading(false)
    }
  };

  return (
    <>
      <div style={{ padding: 20 }}>
        <div className="instructions">
          <Alert message="Negociar os valores referentes à ordem de serviço." />
        </div>

        <div>
          {loading ? (
            <div>
              <Box sx={{ display: "flex" }}>
                <CircularProgress />
              </Box>
            </div>
          ) : (
            <>
              <div>
                <p>Descrição da Negociação</p>
                  <TextArea
                    rows={6}
                    value={info.observacaoNegociacao}
                    onChange={(e) =>
                      setInfo((prevState) => ({
                        ...prevState,
                        observacaoNegociacao: e.target.value,
                      }))
                    }
                  />
              </div>
              <div style={{display: "flex"}}>
                <div style={{margin: 5}}>
                  <p>Valor Avulso</p>
                  <Input
                    placeholder={info.valorAvulso}
                    value={info.valorAvulso}
                    onChange={(e) =>
                      setInfo((prevState) => ({
                        ...prevState,
                        valorAvulso: e.target.value,
                      }))
                    }
                    style={{ width: "255px" }}
                  />
                </div>

                <div style={{margin: 5}}>
                  <p>Valor Mensal</p>
                  <Input
                    placeholder={info.valorMensal}
                    value={info.valorMensal}
                    style={{ width: "255px" }}
                    disabled
                  />
                </div>
              </div>

              <div style={{display: "flex"}}>
                <div style={{margin: 5}}>
                  <p>Valor Assinatura</p>
                  <Input
                    placeholder={info.valorAssinatura}
                    value={info.valorAssinatura}
                    onChange={(e) =>
                      setInfo((prevState) => ({
                        ...prevState,
                        valorAssinatura: e.target.value,
                      }))
                    }
                   style={{ width: "255px" }}
                  />
                </div>

                <div style={{margin: 5}}>
                  <p>Valor Adicional</p>
                  <Input
                    placeholder={info.valorAdicional}
                    value={info.valorAdicional}
                    onChange={(e) =>
                      setInfo((prevState) => ({
                        ...prevState,
                        valorAdicional: e.target.value,
                      }))
                    }
                   style={{ width: "255px" }}
                  />
                </div>
              </div>
            </>
          )}
        </div>

        <div style={{display: "flex", justifyContent: "right", alignItems: "right"}}>
          <Button
            className="bg-color"
            onClick={atualizarNegociacao}
            loading={loading}
            disabled={loading}
          >
            Salvar
          </Button>
        </div>
      </div>
    </>
  );
}

export default NegociacaoOS;
